export default __webpack_public_path__ + "static/database-image-e198cca2f328a1f5e0955b474b998270.png";